import { jsx } from 'panel';
export function template() {
  return jsx("div", {
    class: {
      'view-annotations-button-container': true,
      active: this.isAttributeEnabled("active")
    }
  }, this.attr("num-annotations"));
}